/** inline — legacy look: bordered box only while empty, a picked file renders
 *  as plain text. boxed — the box stays in both states and shows the bare file
 *  name inside (olympiad wizard step 3, Figma 1.3.x). */
export const FileInputVariant = {
  inline: 'inline',
  boxed: 'boxed',
} as const
export type FileInputVariant = (typeof FileInputVariant)[keyof typeof FileInputVariant]
